import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

export const getGobCargos = query =>
	fetch.get(
		`/gob-cargos${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getGobCargo = ({ id, query }) =>
	fetch.get(
		`/gob-cargos/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addGobCargo = data => fetch.post('/gob-cargos', data);
export const updateGobCargo = ({ id, ...data }) =>
	fetch.put(`/gob-cargos/${id}`, data);
export const deleteGobCargo = id => fetch.delete(`/gob-cargos/${id}`);

// RTK Query
export const gobCargosApi = createApi({
	reducerPath: 'gobCargosApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getGobCargos: build.query({
			query: query => {
				return {
					url: `/gob-cargos${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'GobCargos',
								id,
							})),
							{ type: 'GobCargos', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'GobCargos', id: 'LIST' }],
		}),
		getGobCargo: build.query({
			query: ({ id, query }) => {
				return {
					url: `/gob-cargos/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'GobCargos', id }],
		}),
		addGobCargo: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/gob-cargos`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Cargo Gobierno agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar cargo gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'GobCargos', id: 'LIST' }],
		}),
		updateGobCargo: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/gob-cargos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Cargo Gobierno actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar cargo gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'GobCargos', id },
			],
		}),
		deleteGobCargo: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/gob-cargos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Cargo Gobierno eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar cargo gobierno');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'GobCargos', id }],
		}),
	}),
});

export const {
	useGetGobCargosQuery,
	useGetGobCargoQuery,
	useAddGobCargoMutation,
	useUpdateGobCargoMutation,
	useDeleteGobCargoMutation,
} = gobCargosApi;
